import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import { Routes } from '@components/custom'

const Root = () => (
  <React.Fragment>
    {/* Any components global to all pages should go here */}
    <Router basename="/">
      <Routes />
    </Router>
  </React.Fragment>
)

export default Root
